<template>
  <ActionsMenu v-bind="{ actionsBtnItems }" class="h-ml-3" />
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

import ActionsMenu from '@/components/common/ActionsMenu';
import downloadFakeLink from '@/utils/downloadFile';
import loadingMixin from '@/mixins/isLoading';
import tournamentsHelper from '@/mixins/tournaments/tournamentHelpers';
import resetGrid from '@/views/tournaments/management/brackets/mixins/resetGrid';

const FINISHED_STATUSES = ['finished'];
const SCHEDULED_STATUSES = ['scheduled', 'draft'];

export default {
  name: 'BracketsActionsMenu',
  components: {
    ActionsMenu,
  },
  mixins: [loadingMixin, resetGrid, ...tournamentsHelper],
  data() {
    return {
      resetBracketsLoading: false,
      shuffleLoading: false,
      stageID: this.$route.params.stageID,
      blockID: this.$route.params.blockID,
      blockType: this.$route.params.blockType,
      stageActions: [
        {
          key: 'start-stage',
          title: this.$t('_web_tournaments_stage_start-btn', 'Start stage'),
          subtitle: this.$t(
            '_web_tournaments_stage_start-tooltip',
            'Press to start current stage'
          ),
          handler: this.showModalStart.bind(this.stageID),
          icon: 'play-2',
          disabled: !this.canStageStart,
        },
        {
          key: 'publish-stage',
          title: this.$t('_web_tournaments_stage_publish-btn', 'Publish stage'),
          subtitle: this.$t(
            'web_tournaments_stage_publish-tooltip',
            'Press to go publish stage'
          ),
          handler: this.showModalPublish.bind(this.stageID),
          icon: 'publish',
          disabled: !this.canStagePublish,
        },
        {
          key: 'unpublish-stage',
          title: this.$t(
            '_web_tournaments_stage_unpublish-btn',
            'Unpublish stage'
          ),
          subtitle: this.$t(
            'web_tournaments_stage_unpublish-tooltip',
            'Press to go unpublish stage'
          ),
          handler: this.showModalUnPublish.bind(this.stageID),
          icon: 'publish',
          disabled: this.canStagePublish,
        },
      ],
    };
  },
  computed: {
    ...mapGetters(['currentTournamentBlock', 'currentStageInfo']),
    isBattleRoyale() {
      return this.blockType == 'battle-royale';
    },
    competitionStatus() {
      return this.$lodash.get(this.currentTournamentBlock, 'status');
    },
    isCompetitionFinished() {
      return FINISHED_STATUSES.includes(this.competitionStatus);
    },
    isCompetitionScheduled() {
      return SCHEDULED_STATUSES.includes(this.competitionStatus);
    },
    tooltipText() {
      return this.isCompetitionFinished
        ? this.$t(
            '_web_tournament-block_results-export-csv-tooltip',
            'Export results to CSV file'
          )
        : this.$t(
            '_web_tournament-block_results-export-blocked-tooltip',
            'Results export is available only for finished competitions'
          );
    },
    actionsBtnItems() {
      const extraButtons = this.isOneBlockStageTournament
        ? this.stageActions
        : [];

      return [
        ...extraButtons,
        {
          key: 'reset-brackets',
          title: 'Reset brackets',
          subtitle: this.$t(
            '_web_tournament-block_reset-brackets-tooltip',
            'Press to clear all brackets in current stage'
          ),
          handler: this.confirmResetBrackets.bind(
            null,
            this.currentStageInfo,
            false
          ),
          icon: 'reset',
          disabled: !this.isCompetitionScheduled,
        },
        ...(this.isBattleRoyale
          ? []
          : [
              {
                key: 'shuffle-participants',
                title: 'Shuffle participants',
                subtitle: this.$t(
                  '_web_tournament-block_shuffle-participants-tooltip',
                  'Press to shuffle participants inside bracket'
                ),
                icon: 'shuffle',
                handler: this.confirmShuffleParticipants,
                disabled: !this.isCompetitionScheduled,
              },
            ]),
        {
          key: 'players-export-csv',
          title: 'Export Users to CSV',
          subtitle: this.tooltipText,
          icon: 'csv',
          handler: this.exportToCSV,
          disabled: !this.isCompetitionFinished,
        },
      ];
    },
  },
  methods: {
    ...mapMutations(['updateModalProps']),
    ...mapActions([
      'createTournamentPlayersCSV',
      'successNotify',
      'errorNotify',
      'openModal',
      'closeModal',
      'shuffleBlockParticipants',
      'resetBlockBrackets',
      'getTournamentResultsCSV',
    ]),
    // confirmResetBrackets() {
    //   this.openModal({
    //     name: 'HeraConfirm',
    //     props: {
    //       text: this.$t(
    //         '_web_tournament-block_qualifiers_reset_brackets_modal_title',
    //         'This action will trigger reset brackets.'
    //       ),
    //       isLoading: this.resetBracketsLoading,
    //     },
    //     events: {
    //       cancel: this.closeModal,
    //       confirm: this.onResetBrackets,
    //     },
    //   });
    // },
    confirmShuffleParticipants() {
      this.openModal({
        name: 'HeraConfirm',
        props: {
          text: this.$t(
            '_web_tournament-block_qualifiers_reset_brackets_modal_title',
            'This action will trigger shuffle participants.'
          ),
          isLoading: this.shuffleLoading,
        },
        events: {
          cancel: this.closeModal,
          confirm: this.onShuffleParticipants,
        },
      });
    },
    // onResetBrackets() {
    //   this.updateModalProps({ isLoading: true });
    //   this.resetBlockBrackets({
    //     tournamentID: this.tournamentID,
    //     stageID: this.stageID,
    //     blockID: this.blockID,
    //   })
    //     .then(() => {
    //       this.successNotify(
    //         this.$t(
    //           '_web_tournament-block_was-reseted-brackets',
    //           'Brackets reseted'
    //         )
    //       );
    //       this.$emit('update');
    //     })
    //     .catch(this.errorNotify)
    //     .finally(() => {
    //       this.updateModalProps({ isLoading: false });
    //       this.closeModal();
    //     });
    // },
    onShuffleParticipants() {
      this.updateModalProps({ isLoading: true });
      this.shuffleBlockParticipants({
        tournamentID: this.tournamentID,
        stageID: this.stageID,
        blockID: this.blockID,
      })
        .then(() => {
          this.successNotify(
            this.$t(
              '_web_tournament-block_was-participants-shuffled',
              'Shuffle completed'
            )
          );
          this.$emit('update');
        })
        .catch(this.errorNotify)
        .finally(() => {
          this.updateModalProps({ isLoading: false });
          this.closeModal();
        });
    },
    exportToCSV() {
      this.setLoading();
      this.getTournamentResultsCSV({
        stage: this.stageID,
        block: this.blockID,
      })
        .then(res => {
          downloadFakeLink(new Blob([res], { type: 'text/csv' }), 'results');
        })
        .catch(this.errorNotify)
        .finally(this.unsetLoading);
    },
  },
};
</script>
